import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASES_MOVED_PER_OT_QUERY_KEY } from "../types/CommonTypes";

async function getCasesMovedPerOt(
  tenantId: string,
  hospitalId: string,
  queryString: string
) {
  const { data } = await fetcher({
    url: `/analytics/case-movements?${queryString}`,
    method: "GET",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetCasesMovedPerOtQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_CASES_MOVED_PER_OT_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId,
    ],
    queryFn: () => getCasesMovedPerOt(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetCasesMovedPerOtQuery;
